import { Collapser } from '../Collapser';
import _ from 'lodash';

export function collapsibleDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: collapsibleComponentCtrl,
	};
}

class collapsibleComponentCtrl {
	constructor($scope, $element, $attrs) {
		'ngInject';
		$element.css('display', 'none');
		// run setup after attributes have time to be interpolated
		setTimeout(() => {
			$element.css('display', 'block');
			let givenOptions = $scope.$eval($attrs.shCollapsible) || {};
			let options = _.extend(
				{
					isOpen: true,
					duration: 400,
					handleClick: true,
					show: '',
				},
				givenOptions
			);
			new Collapser($element, options);
		}, 0);
	}
}
